<template>
  <el-form
    :model="rule"
    :rules="rules"
    ref="forms"
    class="demo-ruleForm"
    label-width="100px"
  >
    <el-form-item label="机构名称" prop="name">
      <el-input
        placeholder="请输入机构名称"
        v-model="rule.name"
        clearable
      ></el-input>
    </el-form-item>
    <el-form-item label="机构简称" prop="short_name">
      <el-input
        placeholder="请输入机构简称"
        v-model="rule.short_name"
        clearable
      ></el-input>
    </el-form-item>
    <el-form-item label="负责人" prop="owner">
      <el-input
        placeholder="请输入负责人"
        v-model="rule.owner"
        clearable
      ></el-input>
    </el-form-item>
    <el-form-item label="手机号" prop="mobile">
      <el-input
        type="telephone"
        maxlength="11"
        placeholder="请输入手机号"
        v-model="rule.mobile"
        clearable
      ></el-input>
    </el-form-item>
    <el-form-item label="邮箱" prop="email">
      <el-input
        placeholder="请输入邮箱"
        v-model="rule.email"
        clearable
      ></el-input>
    </el-form-item>
    <el-form-item label="地址" prop="address">
      <el-input
        placeholder="请输入地址"
        v-model="rule.address"
        clearable
      ></el-input>
    </el-form-item>
    <el-form-item label="社会信用代码" prop="uscc">
      <el-input
        placeholder="请输入社会信用代码"
        v-model="rule.uscc"
        clearable
      ></el-input>
    </el-form-item>
    <el-form-item label="营业执照" prop="file">
      <div>
        <el-button @click="fileClick">{{
          dialogImageUrl ? "修改文件" : "选择文件"
        }}</el-button>
        <span style="margin-left:20px;margin-right:20px">{{
          rule.file ? rule.file.name : ""
        }}</span>
        <input
          style="display:none"
          type="file"
          name="file"
          @change="getFile($event)"
          ref="fileInput"
        />
        <el-button
          size="mini"
          round
          v-show="dialogImageUrl"
          @click="handlePictureCardPreview"
          >预览</el-button
        >
      </div>
    </el-form-item>
    <el-dialog :visible.sync="dialogVisible" width="90%">
      <template>
        <iframe
          :src="dialogImageUrl"
          style="width: 100%; height: 600px; border: none;"
        ></iframe>
      </template>
    </el-dialog>
    <el-form-item label="子机构设置" prop="allowTag">
      <el-switch
        v-model="rule.allowTag"
      ></el-switch>
    </el-form-item>
    <el-form-item label="父机构" prop="parentId" v-if="rule.allowTag">
      <el-select
        v-model="rule.parentId"
        placeholder="请选择父机构"
        clearable
        filterable
        style="width: 100%"
      >
        <el-option
          v-for="item in parentOptions"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="子机构数量" prop="allowCount" v-if="rule.allowTag">
      <el-input-number
        v-model="rule.allowCount"
        :min="1"
        :max="9999"
        placeholder="请输入允许子机构数量"
        style="width: 100%"
      ></el-input-number>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submit">提交</el-button>
      <el-button @click="block">返回</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    var validPhone = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    var validEmail = (rule, value, callback) => {
      if (!value) {
        callback();
      }
      if (
        !/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(
          value
        )
      ) {
        callback(new Error("请输入正确的邮箱"));
      } else {
        callback();
      }
    };
    return {
      name: "edit",
      dialogImageUrl: "",
      dialogVisible: false,
      parentOptions: [],
      rule: {
        id: 0,
        name: "",
        short_name: "",
        usccFileName:"",
        owner: "",
        file: null,
        mobile: "",
        email: "",
        address: "",
        parentId: null,
        allowCount: 1000,
        allowTag: false,
      },
      rules: {
        name: { required: true, message: "请输入机构名称" },
        short_name: { required: true, message: "请输入机构简称" },
        owner: { required: true, message: "请输入负责人" },
        mobile: [
          { required: true, message: "请输入手机号" },
          { validator: validPhone, trigger: "blur" },
        ],
        email: [{ validator: validEmail, trigger: "blur" }],
        address: { required: true, message: "请输入地址" },
      },
    };
  },
  async created() {
    this.getParentList();
    if (this.$route.params.id) {
      if (this.$store.state.editInfo.length == 0) {
        this.$router.push("/jigou/index");
      } else {
        this.rule = this.$store.state.editInfo;
        // 将后端返回的 allowTag 数字转换为布尔值
        if (this.rule.allowTag !== undefined && this.rule.allowTag !== null) {
          this.rule.allowTag = this.rule.allowTag === 1 || this.rule.allowTag === true;
        }
        // 如果 allowCount 没有有效值，设置为默认值 1000
        if (!this.rule.allowCount || this.rule.allowCount === 0) {
          this.rule.allowCount = 1000;
        }
        this.dialogImageUrl = this.$store.state.editInfo.usccFile;
      }
    }
  },

  methods: {
    getParentList() {
      // 获取父机构列表
      this.$http.post("/manage/institution/list", {
        pageNum: 1,
        pageSize: 1000
      }).then((results) => {
        if (results.data && results.data.data && results.data.data.records) {
          this.parentOptions = results.data.data.records;
          // 如果是编辑模式，过滤掉自己
          if (this.rule.id) {
            this.parentOptions = this.parentOptions.filter(item => item.id !== this.rule.id);
          }
        }
      });
    },
    fileClick() {
      this.$refs.fileInput.click();
    },
    isImage(fileName) {
      return /\.(jpeg|jpg|png|gif)$/i.test(fileName);
    },
    getFile(event) {
      var file = event.target.files;
      console.log("file", file);
      for (var i = 0; i < file.length; i++) {
        //    上传类型判断
        var imgName = file[i].name;
        const validExtensions = [
          ".jpg",
          ".jpeg",
          ".png",
          ".gif",
          ".bmp",
          ".pdf",
        ];
        const isImage = validExtensions.some((ext) => imgName.includes(ext));

        if (isImage) {
          this.rule.file = file[i];
          this.dialogImageUrl = URL.createObjectURL(file[i]);
          this.rule.usccFileName = imgName;
        } else {
          this.$message({
            message: "文件类型仅为图片或pdf格式",
            type: "error",
          });

          this.$refs.fileInput.value = null;
        }
      }
    },
    handlePictureCardPreview() {
      this.dialogVisible = true;
    },
    submit() {
      let headers = {
        "Content-Type": "multipart/form-data",
      };
      this.$refs["forms"].validate((valid) => {
        if (valid) {
          let formData = new FormData();

          Object.keys(this.rule).forEach((key) => {
            // 将 allowTag 布尔值转换为数字，并且始终发送
            if (key === 'allowTag') {
              formData.append(key, this.rule[key] ? 1 : 0);
            } else if (key === 'allowCount') {
              // allowCount 也始终发送，即使为 0
              formData.append(key, this.rule[key] || 0);
            } else if (key === 'parentId') {
              // parentId 可以为空，只在有值时发送
              if (this.rule[key]) {
                formData.append(key, this.rule[key]);
              }
            } else if (this.rule[key] !== null && this.rule[key] !== undefined && this.rule[key] !== '') {
              formData.append(key, this.rule[key]);
            }
            
          });
          if (this.rule.id == 0) {
            this.$http.post("/manage/institution/add", formData,{headers:headers}).then((rs) => {
              if (rs.data.code == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.$router.push("/jigou/index");
              } else {
                this.$message({
                  message: rs.data.message,
                  type: "error",
                });
              }
            });
          } else {
            this.$http
              .post("/manage/institution/edit",formData,{headers:headers})
              .then((rs) => {
                if (rs.data.code == 0) {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.$router.push("/jigou/index");
                } else {
                  this.$message({
                    message: rs.data.message,
                    type: "error",
                  });
                }
              });
          }
        }
      });
    },
    block() {
      this.$router.push("/jigou/index");
    },
  },
};
</script>
